// extracted by mini-css-extract-plugin
module.exports = {"icon":"footer-module--icon--2vroY","socialLinks":"footer-module--socialLinks--gkD34"};